import { render, staticRenderFns } from "./Manfaat.vue?vue&type=template&id=5be49fa1"
import script from "./Manfaat.vue?vue&type=script&lang=js"
export * from "./Manfaat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports